<template>
  <layout title="КП">
    <div class="card">
      <div class="card-header bg-white">
        <h4 class="mb-0">
          Коммерческие предложения
          <Link :href="route('backend.proforma-invoices.create')"
                        :class="{disabled: ! $page.props.can.invoices.create}"
                        class="btn btn-outline-success btn-sm float-right">
            <font-awesome-icon icon="plus"/>
            Добавить КП
          </Link>
        </h4>
      </div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col">
            <search-filter v-model="searchQuery" placeholder="Поиск по компании или городу" autofocus></search-filter>
          </div>
          <div class="col-4">
            <b-form-select v-model="searchStatus">
              <option :value="null">Все</option>
              <option value="1">Новое</option>
              <option value="2">Закрыто</option>
            </b-form-select>
          </div>
        </div>

        <table class="table table-borderless table-sm table-grid">
          <thead>
          <tr>
            <th class="fit">ID</th>
            <th class="fit">Дата</th>
            <th class="fit">Статус</th>
            <th>Компания</th>
            <th>Город</th>
            <th width="120px">Сумма</th>
            <th class="fit"></th>
            <th class="fit"></th>
            <th class="fit"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(invoice) in collection.data" :key="invoice.id">
            <td>
              <small class="text-muted">{{ invoice.id }}</small>
            </td>
            <td>{{ invoice.reference_numbers.galsen.outbound_date }}</td>
            <td>
              <proforma-invoice-status :status="invoice.status"></proforma-invoice-status>
            </td>
            <td>{{ invoice.company.name }}</td>
            <td>{{ invoice.company.city }}</td>
            <td class="fit">
              {{ invoice.sets.reduce((sum, current) => sum + current.price * current.quantity, 0) +
                invoice.custom_items.reduce((sum, current) => sum + current.price * current.quantity, 0) | currency }}&nbsp;₽
            </td>
            <td>
              <button :disabled="! invoice.can.view"
                  class="btn btn-sm btn-outline-secondary"
                  v-b-modal="`proforma-invoice-modal-${invoice.id}`">Просмотр</button>
              <proforma-invoice-modal :invoice="invoice"
                                      :id="`proforma-invoice-modal-${invoice.id}`"></proforma-invoice-modal>
            </td>
            <td>
              <button :disabled="! invoice.can.view"
                      class="btn btn-sm btn-outline-secondary"
                      :id="`proforma-invoice-popover-pdf-${invoice.id}`">Скачать&nbsp;КП</button>
              <b-popover :target="`proforma-invoice-popover-pdf-${invoice.id}`" placement="left"
                         triggers="click blur">
                <template slot="title">Скачать КП</template>
                <div class="btn-group-vertical btn-group-sm">
                  <a :href="route('backend.proforma-invoices.pdf', [invoice.id, 'galsen'])" class="btn btn-secondary">
                    Галсен</a>
                  <a :href="route('backend.proforma-invoices.pdf', [invoice.id, 'globalcomplect'])" class="btn btn-secondary">
                    Глобалкомплект</a>
                  <a :href="route('backend.proforma-invoices.pdf', [invoice.id, 'afanasev'])" class="btn btn-secondary">
                    ИП Афанасьев</a>
                </div>
              </b-popover>
            </td>
            <td>
              <a :class="{disabled: ! $page.props.can.orders.create || ! invoice.can.view }"
                 class="btn btn-sm btn-outline-secondary" :href="route('backend.orders.create', invoice.id)">В&nbsp;заказ</a>
            </td>
            <td>
              <div class="btn-group btn-group-sm" role="group">
                <Link :class="{disabled: ! invoice.can.update}"
                    class="btn btn-outline-secondary" :href="route('backend.proforma-invoices.edit', invoice.id)">
                  <font-awesome-icon icon="pen"/>
                </Link>

                <b-btn :disabled="! invoice.can.delete"
                    variant="outline-secondary" @click="onDelete(invoice.id)">
                  <font-awesome-icon icon="trash"/>
                </b-btn>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <nav v-if="collection.meta">
          <ul class="pagination pagination-sm">
            <li v-for="page in Math.ceil(collection.meta.total / collection.meta.per_page)" :key="page"
                class="page-item" :class="page === collection.meta.current_page ? 'active' : ''">
              <Link class="page-link" :href="`${collection.meta.path}?page=${page}${getQueryParams()}`">
                {{ page }}
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '~/Layouts/Layout'
import SearchFilter from '~/Components/SearchFilter'
import debounce from 'lodash/debounce'
import ProformaInvoiceModal from '~/Components/ProformaInvoice/ProformaInvoiceModal'
import ProformaInvoiceStatus from '~/Components/ProformaInvoice/ProformaInvoiceStatus'

export default {
  components: {
    ProformaInvoiceStatus,
    ProformaInvoiceModal,
    Layout,
    SearchFilter
  },
  props: {
    search: String,
    status: String,
    collection: Object,
    can: Object
  },
  data () {
    return {
      searchStatus: this.status,
      searchQuery: this.search,
      invoices: this.collection.data,
      pagination: this.collection.meta || null
    }
  },
  watch: {
    searchQuery: debounce(function (val, oldVal) {
      if (val === oldVal) {
        return
      }

      this.$inertia.replace(
        this.route('backend.proforma-invoices.index', {
          search: this.searchQuery,
          status: this.searchStatus
        }))
    }, 200),

    searchStatus: debounce(function (val, oldVal) {
      if (val === oldVal) {
        return
      }

      this.$inertia.replace(
        this.route('backend.proforma-invoices.index', {
          search: this.searchQuery,
          status: this.searchStatus
        }))
    }, 200)
  },
  methods: {
    onDelete (invoiceId) {
      if (!confirm('Вы уверены?')) {
        return
      }

      this.$inertia.delete(this.route('backend.proforma-invoices.destroy', invoiceId))
    },

    getQueryParams () {
      const params = (new URL(document.location)).searchParams
      params.delete('page')

      const queryStr = params.toString()

      return queryStr.length > 0 ? '&' + queryStr : ''
    }
  }
}
</script>
